import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSignerContext } from 'signer-app/signer-experience/signer-experience';
import MinimalLayout from 'signer-app/parts/minimal-layout';
import { siteCode } from 'signer-app/pages/confirmation-page/confirmation-page';
import { getWebflowUrl } from 'signer-app/utils/url-helpers';
import { Button } from '@dropbox/dig-components/buttons';
import { signerReassignmentInfoAtom } from 'signer-app/pages/reassign-complete/reassign-modal';
import { useAtomValue } from 'jotai';
import { postMessage, messages } from 'signer-app/utils/messages';
import { Box } from '@dropbox/dig-foundations';
import { PictogramIcon } from '@dropbox/dig-icons';
import { ShareLine } from '@dropbox/dig-icons/dist/mjs/assets';
import * as styles from 'signer-app/pages/reassign-complete/reassign-complete.module.css';
import { Text } from '@dropbox/dig-components/typography';
import { Footer } from 'signer-app/signer-experience/footer';

export function ReassignComplete() {
  const signerReassignmentInfo = useAtomValue(signerReassignmentInfoAtom);
  const { embeddedParentUrl } = useSignerContext();
  const isEmbedded = !!embeddedParentUrl;
  const intl = useIntl();

  const handleIframeClose = React.useCallback(() => {
    if (embeddedParentUrl) {
      postMessage(
        {
          type: messages.USER_FINISH_REQUEST,
        },
        embeddedParentUrl,
      );
    }
  }, [embeddedParentUrl]);

  return (
    <MinimalLayout
      locale={intl.locale}
      siteCode={siteCode}
      contentCentered
      logoHref={getWebflowUrl('', siteCode)}
      variant="900"
    >
      <Box
        className={styles.container}
        display="flex"
        flexDirection="column"
        padding="Macro Small"
        alignItems="center"
        borderColor="Border Subtle"
        borderWidth="1"
        borderStyle="Solid"
      >
        <PictogramIcon src={ShareLine} />
        <Text size="xlarge">
          <FormattedMessage
            id="signer.delegate.complete.documentDelegated"
            description="text in signer flow, informing singer that the signature request has been reassigned to new signer"
            defaultMessage="This document has now been reassigned to {newSignerName}"
            values={{ newSignerName: signerReassignmentInfo?.newSignerName }}
          />
        </Text>

        {!isEmbedded && (
          <Box marginTop="Micro Small">
            <Text size="small" color="subtle">
              <FormattedMessage
                id="signer.delegate.complete.emailConfirmation"
                description="text in signer flow, informing signer that confirmation email will shortly arrive about reassigning the signer"
                defaultMessage="You'll receive a confirmation email shortly."
              />
            </Text>
          </Box>
        )}

        {isEmbedded && (
          <Button
            variant="borderless"
            className="whitelabel-secondary-button"
            onClick={handleIframeClose}
          >
            <FormattedMessage
              id="common.closeButton.labelText"
              description="button text of iFrame , clicking will close iFrame"
              defaultMessage="Close"
            />
          </Button>
        )}
      </Box>
      <Footer />
    </MinimalLayout>
  );
}
